module.exports = __webpack_public_path__ + "static/person-6-70x70-bac0c79f62a0d8d215a7f28108596ed6.png";